import {ConfigContext} from '../../config/context/index.js'
import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class FuelTypeSpecificationVehiclesValueObject extends SpecificationVehiclesValueObject {
  constructor({icon, id, name}) {
    super({icon, id, name})
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return FuelTypeSpecificationVehiclesValueObject.empty()

    const {FUEL_TYPES} = ConfigContext.get('vehicleSpecifications')

    const {icon, name} = FUEL_TYPES[id] || {}

    return FuelTypeSpecificationVehiclesValueObject.createFromLiterals({icon, id, name})
  }
}
